var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5303 13.4697C15.8232 13.7626 15.8232 14.2374 15.5303 14.5303L12.5303 17.5303C12.3897 17.671 12.1989 17.75 12 17.75C11.8011 17.75 11.6103 17.671 11.4697 17.5303L8.46967 14.5303C8.17678 14.2374 8.17678 13.7626 8.46967 13.4697C8.76256 13.1768 9.23744 13.1768 9.53033 13.4697L12 15.9393L14.4697 13.4697C14.7626 13.1768 15.2374 13.1768 15.5303 13.4697ZM11.4697 6.46967C11.7626 6.17678 12.2374 6.17678 12.5303 6.46967L15.5303 9.46967C15.8232 9.76256 15.8232 10.2374 15.5303 10.5303C15.2374 10.8232 14.7626 10.8232 14.4697 10.5303L12 8.06066L9.53033 10.5303C9.23744 10.8232 8.76256 10.8232 8.46967 10.5303C8.17678 10.2374 8.17678 9.76256 8.46967 9.46967L11.4697 6.46967Z",
    fill: "#EDEDF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up-down-arrow.0694ee1e573939569cd57f4a1fa96022.svg";
export { ForwardRef as ReactComponent };